import api from '../_api';

const actions = {
    hpcsubscriptionRequest: ({commit, dispatch}) => {

        return new Promise((resolve, reject) => {
            commit('SUBSCRIPTION_LOADING');

            api.subscriptions()
                .then((resp) => {
                    commit('SUBSCRIPTION_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('SUBSCRIPTION_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    sendSubAction: ({ commit, dispatch }, payload) => {
            let data = {
                id: payload.id,
                action: payload.action
            };

            if(payload.action === 'pause'){
                data.pause_start_date = payload.pause_start_date,
                data.pause_end_date = payload.pause_end_date
            }

            return new Promise((resolve, reject) => {
                commit('SUBSCRIPTION_LOADING');

                api.sendSubAction(data)
                    .then(resp => {
                        resolve(resp.data.data);
                        commit("CLEAR_SUBSCRIPTION_ERRORS");
                    })
                    .catch(err => {
                        let errors = err.response.data;

                        commit("SUBSCRIPTION_ERROR", errors);
                        reject(err.response);
                    });
            })
        },
    clearHpcsubscriptionErrors:({commit}) => {
        commit('CLEAR_SUBSCRIPTION_ERRORS');
    },
    updateCard: ({ commit, dispatch, state }, payload) => {
            let data = {
                cardData: payload.cardPayload,
                action: 'updateCard',
                sub_id: payload.subId
            };

            return new Promise((resolve, reject) => {
                commit("PAYMENT_LOADING");

                api.updateCard(data)
                    .then(resp => {
                        commit("PAYMENT_SUCCESS", resp.data);
                        // dispatch("user/userRequest", null, { root: true });
                        resolve(resp.data.data);
                    })
                    .catch(err => {
                        let errors = err.response.data;

                        commit("PAYMENT_ERROR", errors);
                        reject(err.response);
                    });
            });
        },
        clearPaymentErrors: ({ commit }) => {
            commit("CLEAR_PAYMENT_ERRORS");
        },
}

export default actions
